// extracted by mini-css-extract-plugin
export var image = "_id-0";